import React, { useState } from 'react';
import axios from 'axios';
import logo from "../../src/assets/images/logo-gameblitz.png";
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
const UserLogin = () => {
  const [msisdn, setMsisdn] = useState(''); // State to track the input number
  const loginurl = 'http://localhost:5086/loginuser';
  const navigate = useNavigate();

  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    let formattedMsisdn = msisdn;

    // Check if the number starts with "0" and replace it with "229"
    if (msisdn.startsWith('0')) {
      formattedMsisdn = `229${msisdn.slice(1)}`;
    } else if (!msisdn.startsWith('229')) {
      // If the number does not start with "229" or "0", add "229"
      formattedMsisdn = `229${msisdn}`;
    }

    const data = {
      msisdn: formattedMsisdn, // The formatted number
      service: 'gameblitz' // Service name
    };

    axios.post(loginurl, data)
      .then((response) => {
        console.log('Login response:', response.data);
        if (response.data.status == '1') {
            Cookies.set('msisdn', formattedMsisdn,{expires:1});
            setTimeout(() => {
                navigate(`/home?msisdn=${formattedMsisdn}`);
            }, 1000);
        }
      })
      .catch((error) => {
        console.error('Error during login:', error);
      });
  };

  return (
    <div className='bg-[#818CF8] h-screen py-[80px] flex justify-center'>
      <div>
        <div className='flex justify-center mb-3'>
          <img src={logo} className='w-30 h-20' alt="Logo" />
        </div>
        <div className="w-full max-w-sm p-4 shadow-purple-600 bg-white border border-gray-200 rounded-lg shadow-xl sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <h5 className="text-3xl text-gray-900 dark:text-white font-bold">Login to Gameblitz</h5>
            <div>
              <label htmlFor="number" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Enter Number</label>
              <input
                type="number"
                name="number"
                id="number"
                value={msisdn} // Bind the input value to msisdn state
                onChange={(e) => setMsisdn(e.target.value)} // Update msisdn state on input change
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                placeholder="**********"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
